import {IComponentOptions} from 'angular';
import {IStateService} from 'angular-ui-router';
import ErrorService from '../../../core/errors/service/ErrorService';
import {TSRole} from '../../../models/enums/TSRole';
import TSUser from '../../../models/TSUser';
import {IAuthenticationStateParams} from '../../authentication.route';
import TSAuthLoginElement from '../../model/TSAuthLoginElement';
import AuthServiceRS from '../../service/AuthServiceRS.rest';
import AuthenticationUtil from '../../utils/AuthenticationUtil';
import IFormController = angular.IFormController;
import IHttpParamSerializer = angular.IHttpParamSerializer;
import ILocationService = angular.ILocationService;
import ILogService = angular.ILogService;
import ITimeoutService = angular.ITimeoutService;
import IWindowService = angular.IWindowService;
import ITranslateService = angular.translate.ITranslateService;

let template = require('./authentication.html');
require('./authentication.scss');

export class AuthenticationComponentConfig implements IComponentOptions {
    transclude = false;
    template = template;
    controller = AuthenticationListViewController;
    controllerAs = 'vm';
    bindings: any = {mode: '@'}
}

export class AuthenticationListViewController {

    static $inject: string[] = ['$state', '$stateParams', '$window', '$httpParamSerializer', '$timeout', 'AuthServiceRS'
        , '$location', '$log', 'ErrorService', '$translate'];

    private redirectionUrl: string = '/serf/saml2/jsp/fedletSSOInit.jsp';
    private relayString: string;
    private redirectionHref: string;
    private mode: string;

    private logoutHref: string;
    private redirecting: boolean;
    private countdown: number = 0;
    private loginCedentials: TSAuthLoginElement;
    private form: IFormController;
    private gsBackgroundClass: string;

    constructor(private $state: IStateService, private $stateParams: IAuthenticationStateParams,
                private $window: IWindowService, private $httpParamSerializer: IHttpParamSerializer,
                private $timeout: ITimeoutService, private authService: AuthServiceRS,
                private $location: ILocationService,
                private $log: ILogService, private errorService: ErrorService,
                private $translate: ITranslateService) {
        this.relayString = angular.copy(this.$stateParams.relayPath ? (this.$stateParams.relayPath) : '');

    }

    $onInit() {
        this.loginCedentials = new TSAuthLoginElement();
        //makes it possible to log out using a link
        if (this.$stateParams.type !== undefined && this.$stateParams.type === 'logout') {
            this.doLogout();
        }
        if (this.$stateParams.userID) {
            this.loginCedentials.username = this.$stateParams.userID;
        }
        this.gsBackgroundClass = this.randomGSBackg(); //only do this once
    }

    public getBaseURL(): string {
        //let port = (this.$location.port() === 80 || this.$location.port() === 443) ? '' : ':' + this.$location.port();
        let absURL = this.$location.absUrl();
        let index = absURL.indexOf(this.$location.url());
        let result = absURL;
        if (index !== -1) {
            result = absURL.substr(0, index);
            let hashindex = result.indexOf('#');
            if (hashindex !== -1) {
                result = absURL.substr(0, hashindex);
            }

        }
        return result;
    }

    public singlelogout() {
        this.authService.logoutRequest().then(() => {
            if (this.logoutHref !== '' || this.logoutHref === undefined) {
                this.$window.open(this.logoutHref, '_self');
            } else {
                this.$state.go('start');  // wenn wir nicht in iam ausloggen gehen wir auf start
            }
        });
    }

    public isLoggedId(): boolean {
        console.log('logged in principal', this.authService.getPrincipal());
        return this.authService.getPrincipal() ? true : false;
    }

    public redirect = () => {
        let urlToGoTo = this.redirectionHref;
        console.log('redirecting to login', urlToGoTo);

        this.$window.open(urlToGoTo, '_self');
    };

    public loginClicked() {
        this.errorService.clearError('ERROR_LOGIN');
        if (this.form.$valid) {
            this.errorService.clearAll();
            this.authService.loginRequest(this.loginCedentials)
                .then((response: TSUser) => {
                    this.$log.debug('Successfully logged in');
                    // todo homa: wir sollten uns merken wo wir vorher waren und wenn noetig dahin zurueck
                    if (this.relayString) {
                        console.log(this.relayString);
                    }
                    if (response && response.roles) {
                        let mostPrivilegedRole = this.authService.getHighestRoleOfBenutzer(response.roles);
                        if (mostPrivilegedRole === TSRole.UNASSIGNED_ROLE) {//if no role assigned also warn the user about it
                            this.errorService.addMesageAsError('ERROR_NO_FUNCTIONAL_ROLE');
                        }
                        AuthenticationUtil.navigateToStartPageForRole(mostPrivilegedRole, this.$state);
                    }
                }).catch((err: any) => {
                // Error handling
                this.$log.debug('error: invalid login');
                this.errorService.addValidationError('ERROR_LOGIN');
                //wenn wir eine spezifische meldung haben zeigen wir die auch noch an
                if (err.data && err.data.errorCodeEnum) {
                    let msg: string = err.data.translatedMessage || err.data.errorCodeEnum;
                    this.errorService.addValidationError(msg);
                }
            });

        } else {
            this.$log.debug('Login form was not valid');
        }

    }

    /**
     * triggered einen logout, fuer iam user sowohl in iam als auch in ebegu,
     * bei lokalen benutzern wird auch nur bei uns ausgeloggt
     */
    private doLogout() {
        if (this.authService.getPrincipal()) {  // wenn logged in
            this.authService.logoutRequest();
        }

    }

    public isBenutzerRegVisible(): boolean {
        return this.mode !== 'anlaufstellepruefer';
    }

    public isAnlaufstellenRegVisible(): boolean {
        return this.mode === 'anlaufstellepruefer';
    }

    public getBackground(): string {
        if (this.isBenutzerRegVisible()) {
            return this.gsBackgroundClass;
        } else if (this.isAnlaufstellenRegVisible()) {
            return 'background-as';
        }
        return 'background-gs-1'
    }

    public randomGSBackg(): string {
        let items = ['background-gs-1', 'background-gs-2', 'background-gs-3', 'background-gs-4', 'background-gs-5'];
        let item = items[Math.floor(Math.random() * items.length)];
        return item;
    }

    public getCurrentLang(): string {
        return this.$translate.use();
    }

    public isLangActive(lang: string): boolean {
        return this.getCurrentLang() === lang;
    }

}



// WEBPACK FOOTER //
// ./src/app/authentication/component/loginpage/authenticaton.ts